import type { UserGroupsLocale } from './en'

export const userGroupsTeIn = {
  common: {
    cancel: `రద్దు`,
    close: `మూసివేయి`,
    delete: `తొలగించు`,
    error: `లోపం`,
    yes: `అవును`,
    no: `కాదు`,
    requirePin: `PIN అవసరం`,
    pin: `PIN`,
    auto: `ఆటో`,
  },
  list: {
    title: `వినియోగదారు గుంపులు`,
    searchPlaceholder: `పేరు లేదా సభ్యుని ద్వారా వెతకండి...`,
    searchAriaLabel: `వినియోగదారు గుంపులను వెతకండి`,
    createNew: `కొత్త వినియోగదారు గుంపు`,
    createNewAriaLabel: `కొత్త వినియోగదారు గుంపును సృష్టించండి`,
    tableAriaLabel: `వినియోగదారు గుంపుల పట్టిక`,
    loading: `వినియోగదారు గుంపులు లోడ్ అవుతున్నాయి...`,
    noResultsTitle: `ఫలితాలు కనబడలేదు`,
    noResultsDescription: `మీ శోధన పదాలను మార్చి ప్రయత్నించండి`,
    emptyTitle: `ఇంకా వినియోగదారు గుంపులు లేవు`,
    emptyDescription: `మీ మొదటి వినియోగదారు గుంపును సృష్టించి ప్రారంభించండి`,
    autoGeneratedDeleteTooltip: `ఆటోగా సృష్టించిన గుంపులను తొలగించలేరు`,
    truncatedWarning: `{{total}} గుంపులలో మొదటి {{shown}} వినియోగదారు గుంపులను చూపిస్తోంది. కొన్ని గుంపులు జాబితాలో లేవు — దయచేసి సపోర్ట్‌ను సంప్రదించండి.`,
    actionsForGroup: `{{name}} కోసం చర్యలు`,
    editGroup: `{{name}} ను సవరించు`,
    deleteGroup: `{{name}} ను తొలగించు`,
    deleteGroupDisabled: `{{name}} ను తొలగించు (నిలిపివేయబడింది)`,
    accessAria: `{{label}}: {{status}}`,
    column: {
      name: `పేరు`,
      members: `సభ్యులు`,
      internal: `అంతర్గత`,
      local: `స్థానిక`,
      longDistance: `దూర కాల్`,
      domesticLongDistance: `దూర కాల్`,
      international: `అంతర్జాతీయ`,
      action: `చర్య`,
    },
    pagination: {
      perPage: `ప్రతి పేజీకి:`,
      total: `(మొత్తం {{count}})`,
      resultsPerPage: `ప్రతి పేజీకి ఫలితాలు`,
      previousPage: `మునుపటి పేజీ`,
      nextPage: `తదుపరి పేజీ`,
      jumpToPage: `పేజీ {{page}} కు వెళ్ళండి`,
      morePages: `మరిన్ని పేజీలు`,
    },
    deleteDialog: {
      title: `వినియోగదారు గుంపును తొలగించు`,
      description: `"{{name}}" ను తొలగించాలా? ఇది అన్ని సభ్య సంబంధాలను తీసివేస్తుంది మరియు తిరిగి మార్చలేరు.`,
      successTitle: `వినియోగదారు గుంపు తొలగించబడింది`,
      successDescription: `"{{name}}" తొలగించబడింది.`,
      alreadyDeletedTitle: `ఇప్పటికే తొలగించబడింది`,
      alreadyDeletedDescription: `ఈ వినియోగదారు గుంపు కనబడలేదు - ఇది ఇప్పటికే తొలగించబడి ఉండవచ్చు.`,
      failedDescription: `వినియోగదారు గుంపును తొలగించలేకపోయాం.`,
    },
  },
  form: {
    addTitle: `వినియోగదారు గుంపును జోడించు`,
    editTitle: `వినియోగదారు గుంపును సవరించు`,
    loading: `వినియోగదారు గుంపు లోడ్ అవుతోంది...`,
    loadingError: `వినియోగదారు గుంపు లోడ్ చేయడంలో లోపం: {{message}}`,
    autoGeneratedNotice: `ఆటోగా సృష్టించిన గుంపు - కొన్ని ఫీల్డ్‌లు పరిమితం చేయబడ్డాయి.`,
    nameLabel: `పేరు`,
    namePlaceholder: `గుంపు పేరును నమోదు చేయండి`,
    nameRequired: `పేరు అవసరం.`,
    nameMaxLength: `పేరు 64 అక్షరాలు లేదా అంతకంటే తక్కువ ఉండాలి.`,
    accessPermissions: `ప్రాప్యత అనుమతులు`,
    members: `సభ్యులు`,
    createUserGroup: `వినియోగదారు గుంపును సృష్టించు`,
    saveChanges: `మార్పులను సేవ్ చేయు`,
    access: {
      internal: `అంతర్గత`,
      local: `స్థానిక`,
      domesticLongDistance: `దేశీయ దూర కాల్`,
      international: `అంతర్జాతీయ`,
      tollNumbers: `టోల్ నంబర్లు`,
      maliciousAreaCodes: `హానికర ప్రాంత కోడ్‌లు`,
      superAccess: `సూపర్ యాక్సెస్`,
      eavesdropping: `వినికిడి`,
      promptRecording: `ప్రాంప్ట్ రికార్డింగ్`,
    },
    memberPicker: {
      placeholder: `సభ్యులను ఎంచుకోండి...`,
      searchPlaceholder: `సభ్యులను ఫిల్టర్ చేయండి...`,
      emptyLabel: `ఈ PBX కు వినియోగదారులు కేటాయించబడలేదు.`,
      noResultsLabel: `మీ ఫిల్టర్‌కు సరిపోలే వినియోగదారులు లేరు.`,
      summary_one: `{{count}} సభ్యుడు ఎంచుకోబడ్డాడు`,
      summary_other: `{{count}} సభ్యులు ఎంచుకోబడ్డారు`,
    },
  },
  toast: {
    createdTitle: `వినియోగదారు గుంపు సృష్టించబడింది`,
    updatedTitle: `వినియోగదారు గుంపు నవీకరించబడింది`,
    authRequiredTitle: `ప్రామాణీకరణ అవసరం`,
    authRequiredDescription: `మీ సెషన్ గడువు ముగిసివుండవచ్చు. దయచేసి మళ్లీ ప్రామాణీకరించి ప్రయత్నించండి.`,
    createFailedTitle: `వినియోగదారు గుంపును సృష్టించలేకపోయాం`,
    updateFailedTitle: `వినియోగదారు గుంపును నవీకరించలేకపోయాం`,
  },
} satisfies UserGroupsLocale
